import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { trademarkServices } from '../data/mock';
import { Search, FileText, AlertCircle, Shield, Mail, RefreshCw } from 'lucide-react';

const iconMap = {
  Search,
  FileText,
  AlertCircle,
  Shield,
  Mail,
  RefreshCw
};

export const ServicesSection = ({ onContactClick }) => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            Comprehensive Trademark Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            End-to-end trademark registration and protection services tailored to secure your brand's legal standing.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {trademarkServices.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="border-emerald-200 hover:shadow-xl transition-all duration-300 hover:border-amber-500 hover:-translate-y-1"
              >
                <CardContent className="p-8">
                  <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                    <Icon className="h-8 w-8 text-emerald-700" />
                  </div>
                  <h3 className="text-xl font-bold text-emerald-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {service.description}
                  </p>
                  <Button
                    onClick={onContactClick}
                    variant="link"
                    className="text-amber-600 hover:text-amber-700 p-0 font-semibold"
                  >
                    Learn More →
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={onContactClick}
            size="lg"
            className="bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 shadow-lg"
          >
            Get Started with Trademark Protection
          </Button>
        </div>
      </div>
    </section>
  );
};
